'use client';

import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { CMSFaq } from '@/api/cms/restrictions';
import { ScQuestionAnswer } from '@/components/footerStaticPages/faq/styled';
import { QuestionAnswerItem } from '@/components/QuestionAnswerItem';
import { ThemeMode } from '@/helpers/enums';
import { useMatchingSection } from '@/modules/restrictions/hooks/useAccessSection';
import { ScFAQByGroup } from './styled';

interface IFAQByGroup {
  title?: string;
  withTitle?: boolean;
  sections: CMSFaq[];
}

export const FAQByGroup: FC<IFAQByGroup> = ({
  title,
  withTitle = false,
  sections,
}) => {
  const { t } = useTranslation();
  const [activeAnswerItem, setActiveAnswerItem] = useState<number | null>(null);
  const section = useMatchingSection(sections);
  const items = section?.items;

  if (!items) return null;

  return (
    <ScFAQByGroup>
      {(withTitle || title) && <h2>{title || t('footer.menu.faq')}</h2>}
      <ScQuestionAnswer>
        <div className="questions">
          {items.map(({ question, answer }, index) => (
            <QuestionAnswerItem
              description={answer}
              handleOpen={() =>
                setActiveAnswerItem(index === activeAnswerItem ? null : index)
              }
              isOpen={index === activeAnswerItem}
              key={index}
              mode={ThemeMode.Dark}
              title={question}
            />
          ))}
        </div>
      </ScQuestionAnswer>
    </ScFAQByGroup>
  );
};
